module.exports = __webpack_public_path__ + "img/icon_R1.a51dd141.png";